import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Iris admin module — `/iris` on console.francisquini.ai.
 *
 * Surface is `'admin'` — registered only on the console host. Defence-in-
 * depth: each page wraps `<RequireAdmin>` so a misconfigured router
 * cannot leak admin UI to product users.
 *
 * Backend: `iris.francisquini.ai/v1/admin/*`. Spec:
 * docs/cockpit/dashboards/tier-2-growth-monetizacao.md §2.1.
 */
export const manifest: ModuleManifest = {
  module_id: 'iris',
  display_name: 'Iris',
  surface: 'admin',
  routes: [
    {
      path: '/iris',
      component: () =>
        import('@/routes/_app/iris').then((m) => ({ default: m.IrisHomePage })),
      title: 'Iris — Dashboard',
      permissions: [],
    },
    {
      path: '/iris/deliveries',
      component: () =>
        import('@/routes/_app/iris').then((m) => ({ default: m.IrisDeliveriesPage })),
      title: 'Iris — Deliveries',
      permissions: [],
    },
    {
      path: '/iris/deliveries/$id',
      component: () =>
        import('@/routes/_app/iris').then((m) => ({ default: m.IrisDeliveryDetailPage })),
      title: 'Iris — Delivery detail',
      permissions: [],
    },
    {
      path: '/iris/channels',
      component: () =>
        import('@/routes/_app/iris').then((m) => ({ default: m.IrisChannelsPage })),
      title: 'Iris — Channels',
      permissions: [],
    },
    {
      path: '/iris/users/$userId/preferences',
      component: () =>
        import('@/routes/_app/iris').then((m) => ({ default: m.IrisUserPreferencesPage })),
      title: 'Iris — User preferences',
      permissions: [],
    },
    {
      path: '/iris/threads/$id',
      component: () =>
        import('@/routes/_app/iris').then((m) => ({ default: m.IrisThreadDetailPage })),
      title: 'Iris — Thread detail',
      permissions: [],
    },
  ],
}
